














import { Component, Vue } from 'vue-property-decorator'
import { mapState, mapActions } from 'vuex'

@Component({
  computed: mapState({
    namespaces: (state: any) => state.namespaces.all,
    currentNamespace: (state: any) => state.namespaces.current
  }),
  methods: mapActions({
    selectNamespace: 'namespaces/selectCurrent'
  }),
  created () {
    this.$store.dispatch('namespaces/getAllNamespaces')
  }
})
export default class Navigation extends Vue {
}
